function clearcart() {
  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Failed to clear the cart');
    }
    return response.json();
  })
  .then(data => {
    console.log('Cart cleared:', data);
    const cartDrawer = window.document.querySelector('cart-drawer');
    fetch(`${window.routes.cart_url}?section_id=cart-drawer`)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const newCartDrawer = html.querySelector('cart-drawer');

        if (newCartDrawer && cartDrawer) {
          cartDrawer.innerHTML = newCartDrawer.innerHTML;
          cartDrawer.classList.add('is-empty');
          cartDrawer.open();
        }
      })
      .catch(error => console.error("Error refreshing cart:", error));
  })
  .catch(error => {
    console.error('Error:', error);
  });
}
